export const TIME_SLOT_OTHER = 'other';
export const TIME_SLOT_NONE = 'none';
export const MAX_FIXED_DURATION = 30;
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export type PredefinedTimeSlot = 10 | 15 | 20 | typeof MAX_FIXED_DURATION;
